/* eslint-disable no-underscore-dangle */
window.__SPOTIM_SPOTLIGHT_GO_TO_COMMENTS__ = () => {
  window.document.dispatchEvent(new Event('open-comments'));
};
